/* storybook-check-ignore */
import { css } from '@emotion/react';
import { Flex, Text, Link, Button, BoxProps } from '@opendoor/bricks/core';
import SupportTeamChips from './SupportTeamChips';

export default function HeroSupportSection(props: BoxProps) {
  return (
    <Flex as="section" flexDirection="column" gridGap="1rem" {...props}>
      <SupportTeamChips />
      <Text fontWeight="semibold" fontSize="s1" lineHeight="s1">
        The Exclusives team is here to help
      </Text>
      <Flex flexDirection="row" justifyContent="space-between" gridGap="2rem">
        <Text fontSize="s1" lineHeight="s1">
          Contact us with any questions you have about this home.
        </Text>
        <Flex flexDirection="column">
          <Link
            href="tel:512-706-9938"
            fontSize="s0"
            lineHeight="s00"
            aria-label=""
            style={{ fontWeight: 500 }}
            analyticsName="cosmos-exclusive-phone-opendoor-exclusives"
          >
            512-706-9938
          </Link>
          <Link
            href="mailto:exclusive@opendoor.com"
            fontSize="s0"
            lineHeight="s00"
            analyticsName="cosmos-exclusives-email-opendoor-exclusives"
            aria-label=""
            style={{ fontWeight: 500 }}
          >
            exclusive@opendoor.com
          </Link>
        </Flex>
      </Flex>
      <Button
        css={css`
          &:hover[variant='secondary'] {
            color: var(--colors-brand50);
          }
        `}
        variant="secondary"
        color="brand50"
        borderColor="brand50"
        py="0.75rem"
        height="3rem"
        aria-label=""
        analyticsName="cosmos-opendoor-chat-questions"
        onClick={() => window.FrontChat('show')}
      >
        Questions? Let&apos;s chat
      </Button>
    </Flex>
  );
}
